import Vuex from 'vuex'
import Vue from 'vue'
import images from './modules/images'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    images,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js